import { Routes, Route } from 'react-router-dom';
import BlogPage from './BlogPage';
import BlogPostPage from './BlogPostPage';

export default function BlogRoute() {
  return (
    <Routes>
      <Route index element={<BlogPage />} />
      <Route path=":slug" element={<BlogPostPage />} />
    </Routes>
  );
}
